(() => {
  const elementName = 'ug-jp-spokesperson-products';
  if (customElements.get(elementName)) return;

  class SpokespersonProducts extends HTMLElement {
    connectedCallback() {
      if (this.controller || !this.hasAttribute('data-scroll-color')) return;
      this.hero = this.querySelector('.ug-jpp__hero');
      if (!this.hero) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const schedule = () => this.schedule();
      window.addEventListener('scroll', schedule, { passive: true, signal });
      window.addEventListener('resize', schedule, { passive: true, signal });
      window.addEventListener('pageshow', schedule, { signal });
      document.addEventListener('load', schedule, { capture: true, signal });
      document.addEventListener('shopify:section:load', schedule, { signal });
      document.addEventListener('shopify:section:reorder', schedule, { signal });
      this.observer = new ResizeObserver(schedule);
      this.observer.observe(document.querySelector('#MainContent') || this);
      this.update();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = null;
      this.style.removeProperty('--ug-jpp-progress');
      this.progress = null;
    }

    schedule() {
      if (!this.controller || this.frame != null) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.update();
      });
    }

    update() {
      if (!this.isConnected || !this.controller) return;
      const viewport = Math.max(1, window.innerHeight);
      // Start when the hero enters the viewport and finish at the viewport midpoint.
      // Keep this range independent of the header, which can appear on up-scroll.
      const progress = Math.max(0, Math.min(1, (viewport - this.hero.getBoundingClientRect().top) / (viewport * 0.5)));
      const value = progress.toFixed(4);
      if (value === this.progress) return;
      this.progress = value;
      this.style.setProperty('--ug-jpp-progress', value);
    }
  }

  customElements.define(elementName, SpokespersonProducts);
})();
